import React, { type ComponentProps } from 'react';
import { StyleSheet } from 'react-native';
import { Header } from '@expo/html-elements';
import { type CustomNavigationHeader, theme } from '@sg/garnish';

export const ScanAtCheckoutHeader = (props: ScanAtCheckoutHeaderProps) => {
  const { children } = props;
  return <Header style={styles.header}>{children}</Header>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ScanAtCheckoutHeaderProps = ComponentProps<
  typeof CustomNavigationHeader.Container
>;
